import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'Page',
    component: () => import(/* webpackChunkName: "page" */ '@/views/Page.vue'),
    children: [
      {
      path: '',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    },
    {
      path:'/shencha',
      name: 'SGT',
      component: () => import(/* webpackChunkName: "SGT" */ '@/views/SGT.vue'),
    },
    {
      path:'/bim',
      name: 'BIM',
      component: () => import(/* webpackChunkName: "BIM" */ '@/views/BIM.vue'),
    },
    {
      path:'/qz',
      name: 'QZ',
      component: () => import(/* webpackChunkName: "QZ" */ '@/views/QZ.vue'),
    },
    {
      path:'/ct',
      name: 'CT',
      component: () => import(/* webpackChunkName: "CT" */ '@/views/CT.vue'),
    },
    {
      path:'/sf',
      name: 'SF',
      component: () => import(/* webpackChunkName: "CT" */ '@/views/SF.vue'),
    },
    {
      path:'/lc',
      name: 'LC',
      component: () => import(/* webpackChunkName: "LC" */ '@/views/LC.vue'),
    },
    {
      path:'/nr',
      name: 'NR',
      component: () => import(/* webpackChunkName: "LC" */ '@/views/NR.vue'),
    },
    {
      path:'/fw',
      name: 'FW',
      component: () => import(/* webpackChunkName: "FW" */ '@/views/FW.vue'),
    },
    {
      path:'/cl',
      name: 'CL',
      component: () => import(/* webpackChunkName: "CL" */ '@/views/CL.vue'),
    },
    {
      path:'/zx',
      name: 'ZX',
      component: () => import(/* webpackChunkName: "ZX" */ '@/views/ZX.vue'),
    },
    {
      path:'/jzz',
      name: 'JZ',
      component: () => import(/* webpackChunkName: "JZ" */ '@/views/JZ.vue'),
    },
    {
      path:'/jgg',
      name: 'JG',
      component: () => import(/* webpackChunkName: "JG" */ '@/views/JG.vue'),
    },
    {
      path:'/gpss',
      name: 'GPS',
      component: () => import(/* webpackChunkName: "GPS" */ '@/views/GPS.vue'),
    },
    {
      path:'/ntt',
      name: 'NT',
      component: () => import(/* webpackChunkName: "NT" */ '@/views/NT.vue'),
    },
    {
      path:'/dqq',
      name: 'DQ',
      component: () => import(/* webpackChunkName: "DQ" */ '@/views/DQ.vue'),
    },
    {
      path:'/all',
      name: 'ALL',
      component: () => import(/* webpackChunkName: "ALL" */ '@/views/All.vue'),
    }
  ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
